import {updateAdCredits} from 'app/helpers/adStepper';

export const trackVideoProgress = (playedTime, startSec) => {
  updateAdCredits(playedTime, startSec);
};
